<template>
  <span v-if="careCode" class="mb-0 text-danger">
    <a class="btn btn-primary my-1 btn-ocpb-care-tracking" @click="onClick"
      ><feather-icon icon="EyeIcon" /> ดูรายละเอียดเพิ่มเติม</a
    >

    <ModalOcpbCareHistory ref="modal-ocpb-care-history" />
  </span>
</template>

<script>
import ModalOcpbCareHistory from "./ModalOcpbCareHistory.vue";

export default {
  components: {
    ModalOcpbCareHistory,
  },
  props: {
    comment: {
      type: String,
      default: "",
    },
  },
  computed: {
    // ดึงรหัส OCPB Care จากข้อความความคิดเห็น เช่น "OCPB0269/00466"
    careCode() {
      if (!this.comment) return null;
      let matched = String(this.comment).match(/OCPB\d+\/\d+/i);
      return matched ? matched[0].toUpperCase() : null;
    },
  },
  methods: {
    onClick() {
      if (!this.careCode) return;
      this.$refs["modal-ocpb-care-history"].showByCode(this.careCode);
    },
  },
};
</script>

<style></style>
